export default {"src":"/_next/static/media/enhance_white.53bf62f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};